import { render } from "./RegisterMemberStatus.vue?vue&type=template&id=932f67a0"
import script from "./RegisterMemberStatus.vue?vue&type=script&lang=js"
export * from "./RegisterMemberStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__